module.exports = __webpack_public_path__ + "img/b_desktop.ce2fe849.jpeg";